import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { LuMapPin } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useContinueToLocation from './continue-to-location.controller';

const ID = 'continue-to-location';

const ContinueToLocation = () => {
    const viewProps = useContinueToLocation();

    return (
        <WizardScreenContainer
            id={ID}
            footer={{
                onSubmit: viewProps.onSubmit,
                submitLabel: CommonMessage.BUTTONS.EXIT
            }}>
            {viewProps.isLoading ? (
                <div className='flex size-full items-center justify-center'>
                    <Spinner className='text-border-default fill-brand-primary size-12' />
                </div>
            ) : (
                <div className='flex size-full flex-col items-center justify-center gap-4'>
                    <LuMapPin className='text-brand-primary size-12' />
                    <div className='text-always-black text-center text-lg font-medium'>
                        <FormattedMessage
                            id='kiosk.wizard.continue-to-location.message'
                            defaultMessage='You can now continue to your destination'
                        />
                    </div>
                    {viewProps.spot && <div className='text-foreground-default text-lg font-semibold'>{viewProps.spot.name}</div>}
                </div>
            )}
        </WizardScreenContainer>
    );
};

export default ContinueToLocation;
